
import { ModuleInfo } from "../../fabrix/types";
import translationJson from "./translations.json";
import { createUUID } from "fabrix";
import { icons } from "./icons";
import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";

const moduleRoutes = (): ModuleInfo => {
  let routes = {
    path: "/security-management",
    id: "edbafd3b-489b-4f20-9994-5727173af39d",
    name: "module management",
    label: "SECURITY_MANAGEMENT",
    lazy: async () => {
      const Page = (await import("./")).default;
      return {
        element: (
          <RequireAuth roles={[]}>
            <Page />
          </RequireAuth>
        ),
      };
    },
    icons: icons,
    translations: translationJson,
    children: [
      {
        path: "/security-management/",
        label: "HOME",
        name: "home",
        id: "d311d39f-0eb1-4ea8-9aec-64308045f2b7",
        hide: true,
        lazy: async () => {
          const Page = (await import("./routes/home")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/modules",
        label: "MM_MODULES",
        name: "modules",
        id: "9a558218-7931-41e0-86ce-2aeb40ed9019",
        icon: "mm-modules",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/modules")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/roles",
        label: "MM_ROLES",
        name: "roles",
        id: "0f31be0a-e0d5-4121-90be-6a9d9aa32037",
        icon: "mm-roles",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/roles")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/department-roles",
        label: "MM_DEPARTMENT_ROLES",
        name: "department-roles",
        id: "a2e5e663-69b4-4c8a-8ea5-69823901a42f",
        icon: "mm-department-roles",
        lazy: async () => {
          const Page = (await import("./routes/department-roles")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/users",
        label: "MM_USERS",
        name: "users",
        id: "0ba55aa9-5b09-4d5f-8510-fba0b8257e6f",
        icon: "mm-users",
        lazy: async () => {
          const Page = (await import("./routes/users")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/module-permissions",
        label: "MM_PAGE_PERMISSIONS",
        name: "module-permissions",
        id: "5d0b704c-a763-4754-b80c-de0aaac0e525",
        icon: "mm-page-permissions",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/module-permissions")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/entity-permissions",
        label: "MM_ENTITY_PERMISSIONS",
        name: "entity-permissions",
        id: "2c3c9581-2a38-4b87-ae19-0fe9e117ab87",
        icon: "mm-entity-permissions",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./routes/entity-permissions")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/service-info",
        label: "MM_SERVICE_INFO",
        name: "service-info",
        id: "7a52dd4b-8a41-45ed-806b-7e2a147e0008",
        icon: "mm-service-info",
        roles: ["system-admin", "admin"],
        lazy: async () => {
          const Page = (await import("./services")).default;
          return {
            element: (
              <RequireAuth roles={["system-admin", "admin"]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/security-management/sessions",
        label: "MM_SESSIONS",
        name: "sessions",
        id: "f3f3b6e2-5f4e-4f7a- ninth-4c9e5d6e2b7c",
        icon: "mm-sessions",
        lazy: async () => {
          const Page = (await import("./routes/sessions")).default;
          return {
            element: (
              <RequireAuth roles={[]}>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
    ],
  };
  return routes;
};

export default moduleRoutes;
